export const MODE_MESSAGES = {
  account: {
    view: 'Viewing Account Thresholds',
    edit: 'Editing Account Thresholds',
  },
  transaction: {
    view: 'Viewing Transaction Thresholds',
    edit: 'Editing Transaction Thresholds',
  },
  gts_transaction: {
    view: 'Viewing GTSnet Thresholds',
    edit: 'Editing GTSnet Thresholds',
  },
};

export const BUTTON_MAPPING = {
  Account: 'account',
  Transaction: 'transaction',
  GTSnet: 'gts_transaction',
};
